var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 47,
    viewBox: "0 0 234 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.115 46.7454V0L93.3695 0V46.7454L140.115 46.7454Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.484 46.8669V0.121552L186.739 0.121552V46.8669L233.484 46.8669Z",
    fill: "#55B3E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4302 46.8513V0.105957L46.6849 0.105957L46.6849 46.8513L93.4302 46.8513Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.8 46.8062V0.060791L140.054 0.060791V46.8062L186.8 46.8062Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7454 46.7905L46.7454 0.045105L4.57764e-05 0.045105L4.57764e-05 46.7905L46.7454 46.7905Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4525 46.6852L46.8077 35.0405V46.6852H58.4525Z",
    fill: "#55B3E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0972 46.6852L81.742 46.6852L46.8077 11.751V23.3957L70.0972 46.6852Z",
    fill: "#55B3E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3867 46.6851L46.8077 0.106079L58.4525 0.106079L93.3867 35.0403V46.6851Z",
    fill: "#55B3E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3867 23.3956L70.0972 0.106079L81.742 0.106079L93.3867 11.7508V23.3956Z",
    fill: "#55B3E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.167 35.0405C216.598 35.0405 221.812 29.8269 221.812 23.3957C221.812 16.9645 216.598 11.7509 210.167 11.7509C203.736 11.7509 198.522 16.9645 198.522 23.3957C198.522 29.8269 203.736 35.0405 210.167 35.0405Z",
    fill: "#2E2E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.422 35.0405C169.853 35.0405 175.066 29.8269 175.066 23.3957C175.066 16.9645 169.853 11.7509 163.422 11.7509C156.99 11.7509 151.777 16.9645 151.777 23.3957C151.777 29.8269 156.99 35.0405 163.422 35.0405Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.796 46.7482L140.086 23.4578L116.796 0.167322L93.5054 23.4578L116.796 46.7482Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0628662 0.106842L23.3524 23.3963L0.0628662 46.6859L0.0628662 0.106842Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/Bg2.f0ef77af6d7e78bad2961f1276b64477.svg";
export { ForwardRef as ReactComponent };